import React,{useEffect,useRef, useState} from 'react';
import { Link } from 'react-router-dom';
import Menu from '../icons/Menu';
import Tabmenu from './tabmenu/Tabmenu';
import Symptoms from './chatItems/symptoms';
import SimpleMsg from './chatItems/simpleMsg';
import SimpleMsgRight from './chatItems/simpleMsgRight';
export default function AddMedication() {
  const bottomRef = useRef(null);
  let  [chat,setChat]= useState('');
  let [next,setnext] = useState('');


  const [medication,setMedication] = useState('');
  const [medicationList,setMedicationList] = useState([
    {name:'Capsule or pills',img:'../../../images/capsules.png',color:'#F4EEEF'},
    {name:'Liquids',img:'../../../images/bottlemed.png',color:'#F6F4DF'},
    {name:'Inhaler',img:'../../../images/backpain.svg',color:'#FFE4E4'},
    {name:'Injectables',img:'../../../images/syrinch.png',color:'#EBEDFF'},
    {name:'Topicals',img:'../../../images/topicals.png',color:'#F1F6FF'},
  ])
  const [medicationname,setMedicationname] = useState('');
  const [medicineDosage,setMedicineDosage]= useState('');
  let [dosageduration,setDosageduration] = useState('');
  let [dostime,setDostime] = useState('');
  let [dosenotification,setDosenotification] = useState('');
  
  const chating =(a) => { 

    if(medicationname=='') {
      setMedicationname(chat)
    } else if(medicineDosage=='') {
      setMedicineDosage(a)
    } else if(dosageduration=='') {
      setDosageduration(a)
    }
    setChat('')
  }

  useEffect(() => {
    bottomRef.current?.scrollIntoView({behavior: 'smooth'});
  }, [medication,medicationname,medicineDosage,dostime,dosenotification]);
  return (
    <>
      <div className=" bg-gray-50 min-h-screen">
        <div className='flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 '>
          <div>
          <Link to="/Dashboard">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
            </Link>
          </div>
          <div className='pl-2 flex-1 mt-0.5'>
            <h4 className='font-semibold text-sm'>Add Medication</h4>
          </div>

          <Link to="/AddMedicationManual" className="text-white bg-primary px-2 rounded-xl text-xs -mt-1 h-9 p-2.5">
            <span className='border-2 border-white px-1 pt-0 pb-0.5 rounded-lg text-md'>+</span>&nbsp; Add Manually
          </Link>
        </div>
        <div className='h-20'></div>
        <div className=' justify-between p-4 pt-12'>
          <SimpleMsg msg={"Please provide me with specific details about medicine, and I'll do my best to assist you."} img={'../../../logoico.png'}/>
          <SimpleMsg msg={"Can you choose your medicine forms from below?"} img={'../../../logoico.png'}/>
          <div className=' mt-4'>
          {medicationList.map((s,i)=>(
              <Symptoms color={s.color} value={[s.name,s.img]} symptom={medication} setSymptom={setMedication}/>
            ))}  
          </div>
          {medication&& <> 
            <SimpleMsgRight msg= {medication} img={'../../../logoico.png'}/>
            <SimpleMsg msg={" Please enter medicine name"} img={'../../../logoico.png'}/>
            {medicationname&&<>
              <SimpleMsgRight msg={medicationname} img={'../../../logoico.png'}/>
              <SimpleMsg msg={'What is the appropriate dosage of medicine to be consumed?'} img={'../../../logoico.png'}/>
              <div className='mr-10  flex p-3 gap-2 text-xl'>
                <Symptoms color={'white'} value={[1]} symptom={medicineDosage} setSymptom={setMedicineDosage}/>
                <Symptoms color={'white'} value={[2]} symptom={medicineDosage} setSymptom={setMedicineDosage}/>
                <Symptoms color={'white'} value={[3]} symptom={medicineDosage} setSymptom={setMedicineDosage}/>
                <Symptoms color={'white'} value={[4]} symptom={medicineDosage} setSymptom={setMedicineDosage}/>
              </div>
              {medicineDosage>4 ?
                <SimpleMsgRight msg= {medicineDosage} img={'../../../logoico.png'}/>
              :
               <div className='mr-10 bg-blue-50 flex text-sm p-3 rounded-2xl mb-2 rounded-bl-none'>
                  Or enter manually
                </div>
              }
              {medicineDosage&&<>
                 <SimpleMsg msg={'How long to consume?'} img={'../../../logoico.png'}/>
                <div className='mr-10  flex text-sm p-3 gap-2 '>
                <Symptoms color={'#eff6ff'} value={['Week']} symptom={dosageduration} setSymptom={setDosageduration}/>
                <Symptoms color={'#eff6ff'} value={['Month']} symptom={dosageduration} setSymptom={setDosageduration}/>
                </div>
                {dosageduration!=''?
                  <SimpleMsgRight msg= {dosageduration} img={'../../../logoico.png'}/>
                :
                  <div className='mr-10 bg-blue-50 flex text-sm p-3 rounded-2xl mb-2 rounded-bl-none'>
                    Or enter no, days manually
                  </div>
                }
                {dosageduration&& <>
                  <SimpleMsg msg={'At what time should it be eaten?'} img={'../../../logoico.png'}/>
                  <div className='mr-10   text-sm p-3 gap-2 '>
                    <Symptoms color={'#eff6ff'} value={['08:00 AM']} symptom={dostime} setSymptom={setDostime}/>
                    <Symptoms color={'#eff6ff'} value={['12:00 PM']} symptom={dostime} setSymptom={setDostime}/>
                    <Symptoms color={'#eff6ff'} value={['08:00 PM']} symptom={dostime} setSymptom={setDostime}/>
                    <Symptoms color={'#eff6ff'} value={['Manual']} symptom={dostime} setSymptom={setDostime}/>
                  </div>
                  {dostime&& <>
                    <SimpleMsg msg={'Enable notification when to eat?'} img={'../../../logoico.png'}/>
                    <div className='mr-10   text-sm p-3 gap-2 '>
                      <Symptoms color={'#eff6ff'} value={['yes']} symptom={dosenotification} setSymptom={setDosenotification}/>
                      <Symptoms color={'#eff6ff'} value={['no']} symptom={dosenotification} setSymptom={setDosenotification}/>
                    </div>
                    {dosenotification&&<>
                    <SimpleMsg msg={'Add the next medicine?'} img={'../../../logoico.png'}/>
                    <div className=' mt-4 text-sm grid grid-cols-3 gap-2'>
                      <Link to="/Dashboard" className=' bg-white shadow p-3 text-center rounded-2xl'>Yes</Link>
                      <Link to="/Dashboard" className=' bg-white shadow p-3 text-center rounded-2xl'>No</Link> </div> 
                    </>}
                  </>}
                </>}
              </> }
            </>}
          </>}

        </div>
      </div>       
          
          





      <div className="bg-slate-100 h-16 fixed bottom-0  max-w   w-full text-xs ">
        <div className='flex'>
          <button className='p-2 text-2xl'>+</button>
          <div className='flex-1'>
            <input className='w-full px-6 h-16 bg-slate-100' placeholder='Write here...' type="text" value={chat} onChange={(e)=>setChat(e.target.value)} />
          </div>
          {chat==''?
          <button className='text-center rounded-3xl bg-g p-3 w-12 h-12 hover:bg-green-800 m-1 text-primary' >
            <img src="../../../images/micicon.svg" className="h-6 w-6"/>
          </button>
          :
          <button className='text-center rounded-3xl bg-g p-3 w-12 h-12 hover:bg-green-800 m-1 text-primary text-white' onClick={()=>chating(chat)}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="white" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
            </svg>

          </button>          
          }
        </div>
        
        
      </div>
      <div className='h-16'></div> <div ref={bottomRef} />
      {/* <Tabmenu /> */}
    </>
  );
}